import requestCountry from 'js/lib/requestCountry';
import { useLocation } from 'js/lib/useRouter';

import { getAppUrl } from 'bundles/composable-page-header/utils/appStoreLinks';
import useUserAgent from 'bundles/page/hooks/useUserAgent';

const useIOSInfo = () => {
  const userAgent = useUserAgent();
  const requestCountryCode = requestCountry.get();
  const location = useLocation();
  if (!userAgent || !(userAgent.isIOS || userAgent.isAndroid)) return null;
  const appLink = getAppUrl(userAgent, location.pathname, requestCountryCode);
  return { href: appLink, label: 'Get our app', name: 'get-app' };
};

export default useIOSInfo;
